<template>
  <div id="purchase_point" class="container">
    <DoronPurchaseForm/>
  </div>
</template>

<script>
import DoronPurchaseForm from '@/components/DoronPurchaseForm';

export default {
  name: 'DoronPurchase',
  components: {
    DoronPurchaseForm
  }
};
</script>

<style lang="scss" scoped>
</style>
